/* eslint-disable react/no-children-prop */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import get from 'lodash/get';
import Modal from 'Common/Components/Modal';
import useModal from 'Hooks/useModal';
import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import Message from './components/Message';
import AcceptLabel from './components/AcceptLabel';

const DeletionModal = ({ isOpen, agentToDelete, agentsSelected = [], onAccept, onClose, runStatusLog }) => {
  const intl = useIntl();
  const [ModalWarning] = useModal(Modal);

  const isBulk = !agentToDelete && agentsSelected.length > 0;

  if (!isOpen) return null;

  const agentName = get(agentToDelete, 'name', '');
  const agentExecutionName = get(agentToDelete, '[0].agent_name', '');
  const name = runStatusLog ? agentExecutionName : agentName;

  const deleteTitle = isBulk
    ? `${intl.formatMessage({ id: 'agents.delete.title' })} (${agentsSelected.length})`
    : `${intl.formatMessage({ id: 'agents.delete.title' })} "${name}"`;

  const closeLabel = intl.formatMessage({ id: 'agents.delete.cancel' });

  return (
    <ModalWarning
      onAccept={ onAccept }
      onClose={ onClose }
      title={ deleteTitle }
      acceptLabel={ <AcceptLabel /> }
      closeLabel={ closeLabel }
      children={ <Message agentToDelete={ agentToDelete } runStatusLog={ runStatusLog } isBulk={ isBulk } count={ agentsSelected.length } /> }
    />
  );
};

DeletionModal.propTypes = {
  agentToDelete: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default DeletionModal;
